import React from 'react';
import { useTranslation } from 'react-i18next';
import { ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import styles from './CompletionDonut.module.scss';

interface CompletionDonutProps {
  done?: number;
  total?: number;
  rate?: number;
  color?: string;
  size?: number;
}

const TRACK = '#e5e7eb';

const CompletionDonut: React.FC<CompletionDonutProps> = ({
  done = 0,
  total = 0,
  rate,
  color = '#2563eb',
  size = 96,
}) => {
  const { t } = useTranslation('common');
  const hasData = total > 0 && rate !== undefined;

  const data = hasData
    ? [
        { key: 'done', value: done, color },
        { key: 'rest', value: Math.max(0, total - done), color: TRACK },
      ]
    : [{ key: 'empty', value: 1, color: TRACK }];

  return (
    <div className={styles.wrap} style={{ width: size }}>
      <div className={styles.chart} style={{ width: size, height: size }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              innerRadius="70%"
              outerRadius="100%"
              startAngle={90}
              endAngle={-270}
              stroke="none"
              isAnimationActive={false}
            >
              {data.map((d) => (
                <Cell key={d.key} fill={d.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className={styles.center}>
          {hasData ? (
            <>
              <span className={styles.rate}>{rate}%</span>
              <span className={styles.count}>{done}/{total}</span>
            </>
          ) : (
            <span className={styles.rate}>&ndash;</span>
          )}
        </div>
      </div>
      <span className={styles.caption}>
        {hasData ? t('completion.done', { done, total }) : t('completion.noTasks')}
      </span>
    </div>
  );
};

export default CompletionDonut;
